/**
 * @class ObjectVR
 * @param element HTMLElement
 * @constructor
 */
function ObjectVR(element){
	if(element === null || !(element instanceof HTMLCanvasElement)){
		throw new TypeError("Not a valid HTMLCanvasElement element.");
	}

	this._canvas = element;
	this._document = element.ownerDocument;
	this._window = this._document.defaultView;
	this._documentElement = this._document.documentElement;
	this._animationFrameHandlerBound = this._animationFrameHandler.bind(this);
	this._loadAnimationFrameHandlerBound = this._loadAnimationFrameHandler.bind(this);
	this._pointerEventHandlerBound = this._pointerEventHandler.bind(this);
	this._resizeHandlerBound = this._resizeHandler.bind(this);
	this._deviceOrientationHandlerBound = this._deviceOrientationHandler.bind(this);
	this._orientationHandlerBound = this._orientationHandler.bind(this);

	/** @type NodeList */
	var elements;
	// Object VR
	if((elements = this._document.getElementsByClassName("index_apps")).length){
		this._rootElement = elements[0];
	}
	// Object VR content
	if((elements = this._rootElement.getElementsByClassName("index_apps-content")).length){
		this._contentElement = elements[0];
	}

	// Live collection of elements
	this._positionIndicatorElements = this._document.getElementsByClassName("index_apps-position-indicator");

	// Live collection of elements
	this._instantTaglineElements = this._document.getElementsByClassName("index_apps-instant-tagline");

	// Add generated HTML
	this._canvas.insertAdjacentHTML("afterend", "<div class=\"index_apps-loader\">\n\t<svg class=\"index_apps-loader-decoration\" role=\"presentation\">\n\t\t<circle r=\"110\" class=\"index_apps-loader-decoration-circle\"></circle>\n\t</svg>\n</div>\n<div class=\"index_apps-position\">\n\t<div class=\"index_apps-position-indicator\"></div>\n\t<div class=\"index_apps-position-indicator\"></div>\n\t<div class=\"index_apps-position-indicator\"></div>\n</div>");

	if((elements = this._document.getElementsByClassName("index_apps-tagline")).length){
		var clone;
		var childElement;
		var tagline = elements[0];
		var fragment = document.createDocumentFragment();
		for(var i = 0; i < 1; i++){
			clone = tagline.cloneNode(true);
			clone.className = "index_apps-instant-tagline index_apps-instant-tagline--index-" + i;
			clone.setAttribute("role", "presentation");
			childElement = clone.firstElementChild;
			// Loop on all element children (only one level)
			while(childElement){
				// To update classname
				childElement.className = childElement.className.replace(/index_apps-tagline(-|_|\s|$)/g, "index_apps-instant-tagline$1");
				childElement = childElement.nextElementSibling;
			}
			fragment.appendChild(clone);
		}
		this._canvas.parentNode.insertBefore(fragment, this._canvas.nextSibling);
	}

	if((elements = this._document.getElementsByClassName("index_apps-loader-decoration-circle")).length){
		this._loaderDecorationPathElement = this._prepareLoaderDecorationPath(elements[0]);

	}

	this._createScene(element);

	this._updateCanvasSizes();
	this._contentElement.addEventListener("mousemove", this._pointerEventHandlerBound, false);
	this._window.addEventListener("resize", this._resizeHandlerBound, false);
	this._window.addEventListener("orientationchange", this._orientationHandlerBound, false);
	// Some desktop include motion sensor
	// http://en.wikipedia.org/wiki/Sudden_Motion_Sensor
	// http://superuser.com/questions/582630/do-ssd-based-apple-laptops-contain-accelerometers
	// https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
	// It's complexe to detect touch enabled
	if(window.matchMedia && window.matchMedia('(pointer: coarse), (touch-enabled: 1)').matches || "ontouchstart" in window || Boolean(navigator.msMaxTouchPoints) || Boolean(navigator.maxTouchPoints)){
		this._contentElement.addEventListener("touchstart", this._pointerEventHandlerBound, false);
		this._contentElement.addEventListener("touchmove", this._pointerEventHandlerBound, false);
		this._contentElement.addEventListener("touchend", this._pointerEventHandlerBound, false);
		this._window.addEventListener("deviceorientation", this._deviceOrientationHandlerBound, false);
	}

	this._orientation = this._window.orientation || 0;
	this._sceneProgress = 0;
	this._sceneProgressLastTime = this._sceneProgressStartTime = Date.now();
	this._drawLoader();
	this._loadAnimationFrameRequestID = requestAnimationFrame(this._loadAnimationFrameHandlerBound);
	this._scene.onload = this._sceneLoadHandler.bind(this);
	this._scene.onprogress = this._sceneProgressHandler.bind(this);
	this._scene.load();
}

/** @type HTMLDocument */
ObjectVR.prototype._document = null;
/** @type HTMLElement */
ObjectVR.prototype._documentElement = null;
/** @type DocumentView */
ObjectVR.prototype._window = null;
/** @type HTMLCanvasElement */
ObjectVR.prototype._canvas = null;
/** @type HTMLElement */
ObjectVR.prototype._contentElement = null;
/** @type SVGPathElement */
ObjectVR.prototype._loaderDecorationPathElement = null;
/** @type Scene */
ObjectVR.prototype._scene = null;
ObjectVR.prototype._animationFrameRequestID = 0;
/** @type NodeList|HTMLCollection */
ObjectVR.prototype._positionIndicatorElements = null;
ObjectVR.prototype._positionIndicator = -1;
/** @type NodeList|HTMLCollection */
ObjectVR.prototype._instantTaglineElements = null;
ObjectVR.prototype._instantTagline = -1;
/** @type Boolean */
ObjectVR.prototype._active = true;
/** @type Function */
ObjectVR.prototype._animationFrameHandlerBound = null;
/** @type Function */
ObjectVR.prototype._loadAnimationFrameHandlerBound = null;
ObjectVR.prototype._loadAnimationFrameRequestID = 0;
ObjectVR.prototype._lastFrameTime = 0;
/** @type {Number} Percentage */
ObjectVR.prototype._positionX = 0;
/** @type {Number} Percentage */
ObjectVR.prototype._positionY = 0;
/** @type {Number} Percentage */
ObjectVR.prototype._endPositionX = 0;
/** @type {Number} Percentage */
ObjectVR.prototype._endPositionY = 0;
ObjectVR.prototype._sceneProgress = 0;
ObjectVR.prototype._sceneProgressLastTime = 0;
ObjectVR.prototype._sceneProgressStartTime = 0;
/** @type {Boolean} */
ObjectVR.prototype._dirty = false;
/** @type {Number} in CSS pixels */
ObjectVR.prototype._width = 0;
/** @type {Number} in CSS pixels */
ObjectVR.prototype._height = 0;
ObjectVR.prototype._orientation = 0;
ObjectVR.prototype._pointerEventHandlerBound = null;
ObjectVR.prototype._resizeHandlerBound = null;
ObjectVR.prototype._deviceOrientationHandlerBound = null;
ObjectVR.prototype._orientationHandlerBound = null;
ObjectVR.prototype._useTouch = false;
/** In milliseconds*/
ObjectVR.MOTION_DURATION = 1000;
ObjectVR.AREA_PADDING_X = 60;
ObjectVR.AREA_PADDING_Y = 140;
ObjectVR.AREA_MAX_WIDTH = 1200;
ObjectVR.AREA_MAX_HEIGHT = 800;
/**
 * Define active state
 * @property {Boolean} active
 */
Object.defineProperty(ObjectVR.prototype, "active", {
	/** @this {ObjectVR} */
	set: function active(value){
		if(this._active = Boolean(value)){
			this._setDirty();
		}
	},
	/** @this {ObjectVR} */
	get: function active(){
		return this._active;
	}
});

ObjectVR.prototype._sceneLoadHandler = function _sceneLoadHandler(event){
	window.cancelAnimationFrame(this._loadAnimationFrameRequestID);
	this._rootElement.classList.add("index_apps--loaded");
	//TODO remove loader

	// From right center
	this._positionX = 1;
	this._positionY = 0.5;
	// To left center
	this._endPositionX = 0;
	this._endPositionY = 0.5;
	// (Re)start motion
	this._setDirty(true);
};

/**
 * Use offset to make a progress draw of path
 * @param {SVGPathElement} element
 * @return {SVGPathElement}
 * @private
 */
ObjectVR.prototype._prepareLoaderDecorationPath = function _prepareLoaderDecorationPath(element){
	var totalLength = parseFloat(element.getAttribute("r")) * Math.PI * 2 + 2/* the half of stroke-width in index.less*/;
	// Set invisible path
	element.style.strokeDashoffset = String(totalLength) + "px";
	element.style.strokeDasharray= totalLength + "px " + totalLength + "px";

	return element;
};

ObjectVR.prototype._sceneProgressHandler = function _sceneProgressHandler(event){
	if(event.lengthComputable){
		// We don't have not enough progress events, so we compute speed
		this._sceneProgress = event.loaded / event.total;
		this._sceneProgressLastTime = Date.now();

		// Force to draw the frame now before the browser uncompress the content
		if(this._sceneProgress == 1){
			this._drawLoader();
			// Cancel next further frames
			cancelAnimationFrame(this._loadAnimationFrameRequestID);
		}
	}
};

ObjectVR.prototype._drawLoader = function _drawLoader(){
	// Find an aproximative progress computed with speed (extrapolation)
	var time = Date.now();
	// Global average speed %/ms
	var speed = this._sceneProgress == 0 ? 0 : this._sceneProgress / (this._sceneProgressLastTime - this._sceneProgressStartTime);
	// Interpolate
	var progress = Math.min(speed * (time - this._sceneProgressStartTime), 1);
	// Add the impression of the acceleration of load speed
	var animatedProgress = Transition.cubicIn(progress);
	var totalLength = parseFloat(this._loaderDecorationPathElement.getAttribute("r")) * Math.PI * 2 + 2/* the half of stroke-width in index.less*/;
	this._loaderDecorationPathElement.style.strokeDashoffset = String(totalLength * (1 - animatedProgress)) + "px";
};

ObjectVR.prototype._loadAnimationFrameHandler = function _loadAnimationFrameHandler(){
	this._drawLoader();

	// Next frame
	if(this._sceneProgress < 1){
		this._loadAnimationFrameRequestID = requestAnimationFrame(this._loadAnimationFrameHandlerBound);
	}
};

ObjectVR.prototype._animationFrameHandler = function animationFrameHandler(){
	this._animationFrameRequestID = 0;
	this._drawScene();
};

ObjectVR.prototype._drawScene = function _drawScene(){
	this._dirty = false;
	// Draw scene only if it's loaded and this is active
	if(this._scene.loaded && this.active) {
		var time = Date.now();
		var diffTime = time - this._lastFrameTime;// how many ms elapsed since last frame

		var maxSpeedX = 0.002;//absolute speed in px/ms
		var maxSpeedY = 0.008;//absolute speed in px/ms
		var minSpeedX = 0.000002;//absolute speed in px/ms
		var minSpeedY = 0.000002;//absolute speed in px/ms
//		var speedCoef = 0.005;
		var speedCoefX = 0.008;
		var speedCoefY = 0.012;
		var speedX = Math.max(Math.min((this._endPositionX - this._positionX) * speedCoefX, maxSpeedX), -maxSpeedX);
		var speedY = Math.max(Math.min((this._endPositionY - this._positionY) * speedCoefY, maxSpeedY), -maxSpeedY);
		var positionX = this._positionX + speedX * diffTime;
		var positionY = this._positionY + speedY * diffTime;
		// Simplify near zero speed
		if(Math.abs(speedX) < minSpeedX){
			positionX = this._endPositionX;
		}
		if(Math.abs(speedY) < minSpeedY){
			positionY = this._endPositionY;
		}

		this._scene.draw(positionX, positionY);

		this._updateIndicators(positionX);
		this._updateInstantTaglines(positionX);


		// Need more than one frame to show motion
//		if(progressX < 1 || progressY < 1){
		if(positionX != this._positionX || positionY != this._positionY){
			this._lastFrameTime = time;
			this._animationFrameRequestID = requestAnimationFrame(this._animationFrameHandlerBound);
		}

		// Save new positions
		this._positionX = positionX;
		this._positionY = positionY;
	}
};

ObjectVR.prototype._updateIndicators = function _updateIndicators(progress){
	var element, classList, index, numElements;

	//Update position indicators
	var positionIndicator = -1;
	// First 1/3th
	if(progress <= 1/3){
		positionIndicator = 0;
	}
	// Second 1/3th
	else if(progress <= 2/3){
		positionIndicator = 1;
	}
	// Third 1/3th
	else{
		positionIndicator = 2;
	}

	// If an update is required
	if(positionIndicator != this._positionIndicator){
		this._positionIndicator = positionIndicator;

		for(index = 0, numElements = this._positionIndicatorElements.length; index < numElements; index++){
			element = this._positionIndicatorElements[index];
			classList = element.classList;
			if(index == positionIndicator){
				classList.add("index_apps-position-indicator--current");
			}else if(classList.contains("index_apps-position-indicator--current")){
				classList.remove("index_apps-position-indicator--current");
			}
		}
	}
};

ObjectVR.prototype._updateInstantTaglines = function _updateInstantTaglines(progress){
	var element, classList, index, numElements;

	var instantTagline = -1;
	if(progress <= 0.28){
		instantTagline = 0;
	}else if(progress >= 0.88){
		instantTagline = 0;
	}

	// If an update is required
	if(instantTagline != this._instantTagline){
		this._instantTagline = instantTagline;

		for(index = 0, numElements = this._instantTaglineElements.length; index < numElements; index++){
			element = this._instantTaglineElements[index];
			classList = element.classList;
			if(index == instantTagline){
				classList.add("index_apps-instant-tagline--current");
			}else if(classList.contains("index_apps-instant-tagline--current")){
				classList.remove("index_apps-instant-tagline--current");
			}
		}
	}
};

/**
 *
 * @param event
 */
ObjectVR.prototype._pointerEventHandler = function _pointerEventHandler(event){
	var element = this._contentElement;
	//see @header-sticky-height in style
	var blindY = 46;
	var offsetY = element.getBoundingClientRect().top;

	if(event.type == "touchstart"){
		this._useTouch = true;
	}else if(event.type == "touchend"){
		this._useTouch = false;
		return;
	}

	//Then get new values
	var x;
	var y;
	if("touches" in event){
		// when touchend, event.touches.length == 0
		x = event.touches[0].pageX;
		y = event.touches[0].pageY - offsetY;
	}else{
		x = event.pageX;
		y = event.pageY - offsetY;
	}

	var paddingX = Math.max((this._width - ObjectVR.AREA_MAX_WIDTH) / 2, ObjectVR.AREA_PADDING_X);
	var paddingY = Math.max((this._height - ObjectVR.AREA_MAX_HEIGHT) / 2, ObjectVR.AREA_PADDING_Y);
	this._endPositionX = Math.min(Math.max((x - paddingX) / (this._width - paddingX * 2), 0), 1);
	this._endPositionY = Math.min(Math.max((y - paddingY - blindY) / (this._height - paddingY * 2 - blindY), 0), 1);

	this._setDirty(true);
};

/**
 *
 * @param {boolean} [computeMotion=false] If set to true, recompute startPosition and endPosition based on previous size
 * @private
 */
ObjectVR.prototype._updateCanvasSizes = function _updateCanvasSizes(computeMotion){

	/*
	//TODO
	if(computeMotion){
//		this._width;
//		this._height;
	}*/

	this._width = this._canvas.clientWidth;
	this._height = this._canvas.clientHeight;

	var devicePixelRatio = this._window.devicePixelRatio;
	this._scene.updateSize(
		this._canvas.width = this._width * devicePixelRatio,
		this._canvas.height = this._height * devicePixelRatio
	);

	this._setDirty();
};

/**
 *
 * @param {boolean} [reset=false] Force restart current motion.
 * @private
 */
ObjectVR.prototype._setDirty = function _setDirty(reset){
	// Skip furthers calls
	if(this._dirty){
		return;
	}
	this._dirty = true;

	var animationFrameRequested = this._animationFrameRequestID !== 0;
	if(!animationFrameRequested || reset){
		this._lastFrameTime = Date.now();
	}

	// Requesting one animation frame if it's not already done
	if(!animationFrameRequested) {
		this._animationFrameRequestID = requestAnimationFrame(this._animationFrameHandlerBound);
	}
};

ObjectVR.prototype._resizeHandler = function _resizeHandler(){
	this._updateCanvasSizes();
};

ObjectVR.prototype._deviceOrientationHandler = function _orientationHandler(event){
	// If the user touch the screen skip these events
	if(this._useTouch){
		return;
	}
	var limit = 10;
	var PI = Math.PI;
	var relativeGamma = event.gamma * Math.cos(this._orientation / 180 * PI) + event.beta * Math.sin(this._orientation / 180 * PI);
	var relativeBeta = event.beta * Math.cos(this._orientation / 180 * PI) + event.gamma * Math.sin(-this._orientation / 180 * PI);
	// ratio, where 0.5 == center, 1 = max gamma/beta and 0 = min gamma/beta
	this._endPositionX = Math.max(Math.min(relativeGamma, limit), -limit) / limit * 0.5 + 0.5;
	this._endPositionY = Math.max(Math.min(relativeBeta, limit), -limit) / limit * 0.5 + 0.5;
	this._setDirty(true);
};

ObjectVR.prototype._orientationHandler = function _orientationHandler(event){
	this._orientation = this._window.orientation;
};

ObjectVR.prototype._createScene = function _createScene(element){
	// If WebGL is available
	if(WebGLScene.test(element)){
		var background = new BackgroundLayer("background");
		background.blending = {
			separate: false,
			sFactor: WebGLRenderingContext.DST_COLOR,
			dFactor: WebGLRenderingContext.SRC_COLOR
		};
		background.colors = [
			{
				index: 39 / 211,
				brightness: -36,
				contrast: 20,
				r: 255,
				g: 43,
				b: 47
			},
			{
				index: 98 / 211,
				brightness: 0,
				contrast: 0,
				r: 255,
				g: 200,
				b: 57
			},
			{
				index: 150 / 211,
				brightness: 0,
				contrast: 0,
				r: 15,
				g: 206,
				b: 64
			}
		];
		var object = new WebGLLayer("object");
		object.depth = 0.35;

		var shadow = new WebGLLayer("shadow");
		shadow.depth = .05;
		shadow.zoomLevel = 1.1;
		shadow.zoomOffsetX = 0.1;
		shadow.blending = {
			separate: false,
			sFactor: WebGLRenderingContext.DST_COLOR,
			dFactor: WebGLRenderingContext.ZERO
		};

		var phone = new WebGLLayer("phone");
		phone.depth = 1.15;
		/*num images: 211 or 160 [18->177]*/
		this._scene = new WebGLScene(element, {
			src4096: this._canvas.dataset.srcWebgl4096,
			size4096: this._canvas.dataset.sizeWebgl4096,
			src2048: this._canvas.dataset.srcWebgl2048,
			size2048: this._canvas.dataset.sizeWebgl2048
		}, [
			background, object, shadow, phone
		]);
	}
	// Else standard Canvas
	else if(SimpleScene.test(element)){
		this._scene = new SimpleScene(element, this._getURIsFromTemplate(this._canvas.dataset.src));
	} else{
		throw new Error("Unable to create a valid Scene");
	}
};

/**
 * Get URIs from a template URI
 * @param {String} template
 * @returns {Array.<String>}
 * @private
 * @see http://www.downthemall.net/howto/help/english-menu/batch-downloadsbatch-descriptors/
 * @see https://github.com/downthemall/downthemall-mirror/blob/33fa35d382051f6833dbb92eb31281ae07d92b2c/modules/support/batchgen.js
 */
ObjectVR.prototype._getURIsFromTemplate = function _getURIsFromTemplate(template){
	var matches;
	var count;
	var index;
	var start;
	var end;
	var step = 1;
	var strLength;
	var str;
	var urls;
	var prefix;
	var postfix;

	if(matches = template.match(/\[(\d+):(\d+)(?::(\d+))?\]/)){
		// First part
		prefix = template.substring(0, matches.index);
		// Last part
		postfix = template.substr(matches.index + matches[0].length);
		// First value
		start = parseInt(matches[1], 10);
		// Second value
		end = parseInt(matches[2], 10);
		// Check output string number length: "100" or "00100"?
		strLength = matches[1].length;
		// Third value
		if (matches.length > 3 && matches[3] !== undefined) {
			step = parseInt(matches[3], 10);
		}
		count = Math.floor((end - start) / step) + 1;
		// Create an array with right length
		urls = new Array(count);

		for(index = 0; index < count; index++){
			str = String(start + index * step);
			if(str.length < strLength){
				str = "0".repeat(strLength - str.length) + str;
			}
			urls[index] = prefix + str + postfix;
		}

		return urls;
	}else{
		return [template];
	}
};

ObjectVR.prototype.clear = function clear(){
	this._contentElement.removeEventListener("mousemove", this._pointerEventHandlerBound, false);
	this._contentElement.removeEventListener("touchstart", this._pointerEventHandlerBound, false);
	this._contentElement.removeEventListener("touchmove", this._pointerEventHandlerBound, false);
	this._contentElement.removeEventListener("touchend", this._pointerEventHandlerBound, false);
	this._window.removeEventListener("resize", this._resizeHandlerBound, false);
	this._window.removeEventListener("deviceorientation", this._deviceOrientationHandlerBound, false);
	this._window.removeEventListener("orientationchange", this._orientationHandlerBound, false);
	cancelAnimationFrame(this._loadAnimationFrameRequestID);
	cancelAnimationFrame(this._animationFrameRequestID);
	if(this._scene){
		this._scene.onload = null;
		this._scene.onprogress = null;
		this._scene.clear();
	}

	return true;
};